import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';

import s from './PromoMessage.scss';

function PromoMessage({ isAssociate }) {
  return (
    <div className={cn(s.noPromos, 'bodySecondary')}>
      {isAssociate ? 'Associate and Style Editor discounts are not stackable with additional offers.'
        : 'No personal offers at this time, check back soon'}
    </div>
  );
}

PromoMessage.propTypes = {
  isAssociate: PropTypes.bool,
};

PromoMessage.defaultProps = {
  isAssociate: false,
};

export default PromoMessage;
